/*
 * Authors: mariushirjanu
 * Created: 15/06/2022
 *
 * Allow to display an alert in formly
 */
import { Component, Input, OnInit } from '@angular/core';
import { Alert } from '../../app-styles';

@Component({
  selector: 'formly-alert',
  template: `
    <div class="alert" [ngClass]="alertClass">
      <i class="fa" [ngClass]="iconClass"></i>&nbsp;<span [innerHTML]="message" translate></span>
    </div>
  `
})
export class FormlyAlertComponent implements OnInit {
  @Input() public message:string;
  @Input() public alertClass:Alert|string;
  public iconClass:string;

  constructor(
  ) {
    /***/
  }

  public ngOnInit():void {
    this.iconClass = this.getIconClass();
  }

  private getIconClass():any {
    const ALERT_REGEXP:RegExp = /alert-[\w]*/;
    const matchArray:RegExpMatchArray = this.alertClass.match(ALERT_REGEXP);
    const match:string = matchArray && matchArray[0];

    switch (match) {
      case Alert.DANGER: return 'fa-exclamation-circle';
      case Alert.WARNING: return 'fa-warning';
    }
  }
}